import React, { useContext } from "react";
import { Alert, Box, CircularProgress } from "@mui/material";
import { Navigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../AppContext";
import { PosContext } from "../../shared/PosContext";
import { getTakeawayUrlSegment } from "../../utils/floorUtils";
import PosPage from "../PosPage";

export default function Kiosk() {
    const { t } = useTranslation();
    const { posProfile } = useContext(AppContext);
    const { takeawayTable, isAppLoading } = useContext(PosContext);
    const { tableName } = useParams();
    const kioskTable = posProfile?.takeaway_table || takeawayTable?.name;
    const kioskTableSegment = getTakeawayUrlSegment(posProfile, takeawayTable);

    if (isAppLoading && !kioskTable) {
        return (
            <Box sx={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!kioskTable) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="warning">
                    {t("kiosk.configurationError")}
                </Alert>
            </Box>
        );
    }

    if (!tableName || tableName !== kioskTableSegment) {
        return (
            <Navigate
                to={`/kiosk/${kioskTableSegment}`}
                replace
            />
        );
    }

    return <PosPage kioskMode />;
}
